module.exports = __webpack_public_path__ + "img/sidebardownarrow.29e0be9b.svg";